import { render, staticRenderFns } from "./RoomScheduleTab.vue?vue&type=template&id=bd6ce4fc&scoped=true&lang=pug"
import script from "./RoomScheduleTab.vue?vue&type=script&lang=ts"
export * from "./RoomScheduleTab.vue?vue&type=script&lang=ts"
import style0 from "./RoomScheduleTab.vue?vue&type=style&index=0&id=bd6ce4fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6ce4fc",
  null
  
)

export default component.exports